export const AutoPayMessages = {
  SUCCESS_EDIT: 'You have successfully updated your payment method for',
  SUCCESS_NEW: 'You have successfully set up AutoPay for',
  FAIL: 'We are unable to process your request right now. Please try again later.',
  STOP: 'You have successfully stopped AutoPay for',
  BULK_SUCCESS: 'AutoPay was successfully set up for the following:',
  BULK_FAIL: 'AutoPay was not set up for the following',
};

export const paymentTermsAndConditions = (buttonText = 'Save') =>
  `By selecting ${buttonText}, you agree to the `;
